import createIcon from '../../createIcon';

/**
 * @component @name ForkRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNTkgMTUuNTlMMTUgMTdMMTkgMTNMMTUgOUwxMy41OSAxMC40MUwxNS4xNyAxMkMxMy42NiAxMS42NyAxMS40NCAxMi4wOCAxMCAxMy4zNlY2LjgzTDExLjU5IDguNDJMMTMgN0w5IDNMNSA3TDYuNDEgOC40MUw4IDYuODNWMjFIMTBWMTdDMTAuNzMgMTQuNDIgMTMuMDcgMTMuNTMgMTUuMTcgMTRMMTMuNTkgMTUuNTlaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ForkRight = createIcon('ForkRight', [
  [
    'path',
    {
      d: 'M13.59 15.59L15 17L19 13L15 9L13.59 10.41L15.17 12C13.66 11.67 11.44 12.08 10 13.36V6.83L11.59 8.42L13 7L9 3L5 7L6.41 8.41L8 6.83V21H10V17C10.73 14.42 13.07 13.53 15.17 14L13.59 15.59Z',
      key: '1n7j6e',
    },
  ],
]);

export default ForkRight;
